import React, { useContext, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Breadcrumb } from "semantic-ui-react"
import { useOrgStore } from "../../store/OrgStore";
import UserContext from "../../contexts/UserContext";

const BreadCrumbs = () => {

    const userContext = useContext(UserContext)

    const navigate = useNavigate()
    const params = useParams()

    const orgStore = useOrgStore()

    let crumbs = []
    if(orgStore.org && params.org){
        crumbs.push(orgStore.org)
    }
    if(orgStore.site && params.site){
        crumbs.push(orgStore.site.label)
    }
    if(orgStore.asset && params.asset){
        crumbs.push(orgStore.asset.asset.assetName)
    }

    function nav(index){
        let urlSplit = window.location.pathname.split("/").slice(2)
        let url = urlSplit.slice(0, index + 1)
        navigate('/organization/' + url.join("/"))
    }

    useEffect(() => {
        if(!params.asset){
            orgStore.clear_asset()
        }
        if(params){
            if(params.site && params.org){
                let site = userContext.userInfo.site_list.find(i => i.label === params.site)
                orgStore.set_org_site(params.org, site)
            } else if (params.org){
                orgStore.set_org_site(params.org, "")
            } else {
                orgStore.set_org_site("", "")
            }
        }
    }, [params])

    return (
        <Breadcrumb size="large">
            <Breadcrumb.Section link onClick={() => navigate('/organization')} >Home</Breadcrumb.Section>
            {crumbs.map((c, index) => {
                if(index !== crumbs.length -1){
                    return (
                        <React.Fragment key={index}>
                        <Breadcrumb.Divider icon='right chevron' />
                        <Breadcrumb.Section link onClick={() => nav(index)}>{c}</Breadcrumb.Section>
                        </React.Fragment>
                    )
                } else {
                    return (
                        <React.Fragment key={index}>
                        <Breadcrumb.Divider icon='right chevron' />
                        <Breadcrumb.Section >{c}</Breadcrumb.Section>
                        </React.Fragment>
                    )
                }

            })}
        </Breadcrumb>
    )

}

export default BreadCrumbs